@if (modalOpen()) {
    <div
        cdkScrollable
        class="modal-container"
        animate.enter="modal-enter"
        animate.leave="modal-leave"
        [class.allow-wide]="allowWide()"
        [class.allow-overflow]="allowOverflow()"
        (click)="handleModalClose($event)"
    >
        <div class="modal-inner-container" [class]="size()">
            <div class="modal-content-container">
                <div class="stby-modal">
                    @if (!denyClose()) {
                        <div class="close-button" (click)="onClickCloseButton()">
                            <stby-icon icon="close" />
                        </div>
                    }
                    <h3 class="modal-title" [class.hidden]="!modalTitleHasContent()">
                        <ng-content select="stby-modal-title"></ng-content>
                    </h3>
                    <div class="stby-modal-content" [class.hidden]="!modalContentHasContent()">
                        <ng-content select="stby-modal-content"></ng-content>
                    </div>
                    <div class="modal-cta-container" [class.hidden]="!modalCtaHasContent()">
                        <ng-content select="stby-modal-cta"></ng-content>
                    </div>

                    <ng-content select="[modal-content]"></ng-content>
                </div>
            </div>
        </div>
    </div>
}
